/**
 * Load a script sourced from a local or external js file
 * @param {string} src - the script src attribute value
 * @returns {Promise<void>} - resolves after the script has been executed
 */
export const loadScript = (() => {
  // If attemtping to load the same script multiple times, each attempt
  // will be collected in pendingResolvers until the script is loaded,
  // at which point all resolvers for that script will be resolved.
  const pendingResolvers = {};

  return function (src: string): Promise<void> {
    return new Promise((resolve) => {
      const scriptId = `load-script-${src}`;
      const existingScript = document.getElementById(scriptId);

      pendingResolvers[src] = pendingResolvers[src] || [];
      pendingResolvers[src].push(resolve);

      if (existingScript) {
        return;
      }

      const scriptEl = document.createElement('script');

      scriptEl.setAttribute('src', src);
      scriptEl.setAttribute('id', scriptId);
      scriptEl.addEventListener('load', function () {
        pendingResolvers[src].forEach((resolver) => resolver());
        delete pendingResolvers[src];
      });

      document.head.appendChild(scriptEl);
    });
  };
})();
